<template>
  <BaseVeeForm :action="updateUser" ensure-error-keys-camel-case>
    <template #default="formProps">
      <div>
        <ValidationProvider name="user id" slim vid="userId">
          <template #default="{ errors }">
            <BaseFormGroup>
              <BaseFormSelect
                v-model="formData.userId"
                :options="userOptions"
                :disabled="formProps.isPending"
                required
                class="w-full"
                @change="formProps.submit"
              />
              <BaseFormInlineMessage v-if="errors.length" danger>
                {{ errors[0] }}
              </BaseFormInlineMessage>
            </BaseFormGroup>
          </template>
        </ValidationProvider>
      </div>
    </template>
  </BaseVeeForm>
</template>

<script>
export default {
  inject: ['refresh'],
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        userId: null,
      },
    };
  },
  computed: {
    user() {
      return this.$store.getters['ui/contactRequestUser/itemByParent'](this.contactRequest.id);
    },
    members() {
      return this.$store.getters['ui/accountMembers/membersByAccount'](
        this.contactRequest.accountId
      );
    },
    userOptions() {
      const userOptions = [
        {
          value: null,
          label: 'Unassigned',
        },
        ...this.members
          .filter((member) => {
            if (!this.$hasRole('user')) {
              return true;
            }

            return this.memberHasRole(member, 'user');
          })
          .map((member) => ({
            value: member.id,
            label: `${member.firstName} ${member.lastName}`,
          })),
      ];

      if (this.user && userOptions.findIndex((option) => option.value === this.user.id) === -1) {
        userOptions.push({
          value: this.user.id,
          label: `${this.user.firstName} ${this.user.lastName}`,
        });
      }

      return userOptions;
    },
  },
  created() {
    this.formData.userId = this.contactRequest?.userId || null;
  },
  destroyed() {
    this.$store.commit('ui/contactRequestUser/setIdByParent', {
      parentId: this.contactRequest.id,
      id: null,
    });
  },
  methods: {
    getMembership(membershipOrMembershipId = null) {
      let membership = null;

      if (typeof membershipOrMembershipId === 'object') {
        membership = membershipOrMembershipId;
      }

      if (typeof membershipOrMembershipId === 'string') {
        membership = this.$store.state.entities.memberships.byId[membershipOrMembershipId] || null;
      }

      return membership;
    },
    memberHasRole(member, role) {
      const membership = this.getMembership(member.membership);

      if (!membership) {
        return false;
      }

      return this.membershipHasRole(membership, role);
    },
    getRole(roleOrRoleId = null) {
      let role = null;

      if (typeof roleOrRoleId === 'object') {
        role = roleOrRoleId;
      }

      if (typeof roleOrRoleId === 'number') {
        role = this.$store.state.entities.roles.byId[roleOrRoleId] || null;
      }

      return role;
    },
    getRoles(rolesOrRoleIds = []) {
      return (Array.isArray(rolesOrRoleIds) ? rolesOrRoleIds : [rolesOrRoleIds])
        .map(this.getRole)
        .filter(Boolean);
    },
    membershipHasRole(membership, role) {
      const roles = this.getRoles(membership.roles);

      return roles.some((r) => r.name === role);
    },
    async updateUser() {
      try {
        await this.$store.dispatch('ui/contactRequestUser/update', {
          id: this.contactRequest.id,
          formData: this.formData,
        });

        if (typeof this.refresh === 'function') {
          this.refresh();
        }

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
